import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Costs, SettlementStatus} from '@app/models/costs';
import {Router} from '@angular/router';
import {format} from 'date-fns';

@Component({
  selector: 'app-costs-view',
  templateUrl: './costs-view.component.html',
  styles: [`
    :host ::ng-deep .p-tag {
      font-size: 0.9rem;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostsViewComponent implements OnInit {
  @Input() costs: Costs;
  @Input() golfer: number;
  @Input() cart = 0;
  @Input() caddy = 0;
  @Output() refundDetailsClick = new EventEmitter<any>();

  public SettlementStatus = SettlementStatus;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  /**
   * Calculate greenfee total (unit cost × golfers)
   */
  getGreenfeeTotal(): number {
    return (this.costs?.greenfee || 0) * (this.golfer || 0);
  }

  /**
   * Calculate cart total (unit cost × carts)
   */
  getCartTotal(): number {
    return (this.costs?.cart || 0) * (this.cart || 0);
  }

  /**
   * Calculate caddy total (unit cost × caddies)
   */
  getCaddyTotal(): number {
    return (this.costs?.caddy || 0) * (this.caddy || 0);
  }

  /**
   * Calculate subtotal of core costs
   */
  getInitialCost(): number {
    if (!this.costs) {
      return 0;
    }

    let subtotal = 0;
    subtotal += this.getGreenfeeTotal();
    subtotal += this.getCartTotal();
    subtotal += this.getCaddyTotal();
    return subtotal;
  }

  onEnterRefundDetails() {
    this.refundDetailsClick.emit(this.costs);
  }

  navigateToTransferPage() {

    if (this.costs?.transferScheduledDate) {
      const formattedDate = format(new Date(this.costs.transferScheduledDate), 'yyyy-MM-dd');
      this.router.navigateByUrl(`/transfers/daily?payment-due-date=${formattedDate}`);
    }
  }
}
